import(/* webpackMode: "eager" */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager" */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\node_modules\\next\\dist\\client\\image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\components\\layout\\Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\components\\layout\\Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\KAY\\Kay Websites\\JS Sites\\Next\\Samwarthika\\src\\app\\your-ultimate-ayurvedic-medical-tourism-guide-in-2025\\BlogPage.tsx");
